// export const firebaseConfig = {
//     //put firebase config here
//     apiKey: "AIzaSyBlfFaGBx7B_nBnlR29yhJAr6kPjqAdLfo",
//     authDomain: "test-84ae7.firebaseapp.com",
//     databaseURL: "https://test-84ae7.firebaseio.com",
//     projectId: "test-84ae7",
//     storageBucket: "test-84ae7.appspot.com",
//     messagingSenderId: "762464277938"
// };
export const firebaseConfig = {
    apiKey: "AIzaSyAldF3HRwUKCpzSid5MFtEEakwNYg12M6I",
    authDomain: "song-of-distance-47ab8.firebaseapp.com",
    databaseURL: "https://song-of-distance-47ab8.firebaseio.com",
    projectId: "song-of-distance-47ab8",
    storageBucket: "song-of-distance-47ab8.appspot.com",
    messagingSenderId: "807349511024",
    appId: "1:807349511024:web:bfabe2b53857e837d665b5",
    measurementId: "G-6D96Y0D4KW"
};
//   // Initialize Firebase
//   firebase.initializeApp(firebaseConfig);
//   firebase.analytics();

export const serverIP = 'https://gps-250305.appspot.com'; // change IP here
//https://gps-250305.appspot.com